<template>
  <div class="card-variant">
    <div class="card-variant__top">{{ platform }}</div>
    <div class="card-variant__item">
      <div class="card-variant__value">{{ formatDate(date) }}</div>
      <div class="card-variant__prop">Last active</div>
    </div>
    <div class="card-variant__item">
      <div class="card-variant__value">{{ version }}</div>
      <div class="card-variant__prop">Version and build</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  version: {
    type: String,
    default: null,
  },
  platform: {
    type: String,
    default: null,
  },
  date: {
    type: String,
    default: null,
  },
});

const formatDate = (date) => {
  const dateNew = new Date(date);

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };

  const formattedDate = dateNew.toLocaleString("en-US", options);
  return formattedDate;
};
</script>

<style lang="scss" scoped>
.card-variant {
  border-radius: var(--Radius-border-radius-base, 4px);
  border: var(--Radius-border-radius-none, 1px) solid
    var(--Color-Border-border-color-lighter, #ebeef5);
  background: var(--Color-Fill-fill-color-blank, #fff);
  &__top {
    color: var(--Color-Text-text-color-primary, #303133);
    font-size: 14px;
    font-weight: 800;
    line-height: 22px; /* 157.143% */
    padding: 9px 12px;
    // &::first-letter {
    //   text-transform: uppercase;
    // }
  }
  &__item {
    display: flex;
    align-items: center;
    padding: 9px 12px;
    border-top: 1px solid var(--Color-Border-border-color-lighter, #ebeef5);
  }
  &__prop {
    color: var(--Color-Text-text-color-placeholder, #a8abb2);
    text-align: right;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    flex-grow: 1;
  }
  &__value {
    width: 58%;
    color: var(--Color-Text-text-color-regular, #606266);
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
}
</style>
